module.exports = __webpack_public_path__ + "static/media/Montserrat-Medium.4193cb37.woff2";